<template>
    <div class="infoContent">
        <div class="topInfo">
            <el-form ref="form" :model="form" label-width="100px">
                <div class="topTitle">1、基础信息</div>
                <el-form-item label="活动名称:">
                    <el-select v-model="form.name" placeholder="请选择" v-if="addType == 'add'">
                        <el-option :label="item.name" :value="item.id" v-for="(item,index) in form.activityList" :key="index" @click.native="activeSelect(item)"></el-option>
                    </el-select>
                    <div class="name" v-else>{{ form.name }}</div>
                </el-form-item>
                <el-form-item label="活动说明:">
                    <div class="remark">{{ form.remark }}</div>
                </el-form-item>
                <el-form-item label="活动时间:" class="dateBox">
                    <el-date-picker type="date" placeholder="选择开始时间" v-model="form.creatDate" value-format="yyyy-MM-dd"></el-date-picker>
                    <div class="line" :span="2">-</div>
                    <el-date-picker type="date" placeholder="选择结束时间" v-model="form.endDate" value-format="yyyy-MM-dd" @change="endDateChange"></el-date-picker>
                </el-form-item>
                <el-divider></el-divider>
                <div class="topTitle">2、规则定制</div>
                <!-- <div class="ruleBox">
          <div class="ruleLeft">
            <div class="ruleList" v-for="(item,index) in form.ruleList" :key="index">
              <p class="rule rule1">充值</p>
              <p class="rule rule2">{{ item.rechargeAmount }}</p>
              <p class="rule rule3">赠送</p>
              <p class="rule rule4">{{ item.giveAmount }}</p>
              <div>
                <div class="couponsList" v-for="(i,d) in item.give" :key="d">
                  <el-radio v-model="i.couponUseScopeType" :label="1" @input="couponsBtn(1,i)">台费券</el-radio>
                  <el-radio v-model="i.couponUseScopeType" :label="2" @input="couponsBtn(2,i)">水机券</el-radio>
                  <el-select class="selectNum" v-model="i.couponNum" placeholder="请选择数量" clearable value-key="key">
                    <el-option :label="j" :value="j" v-for="(j,e) in i.selectList" :key="e"></el-option>
                  </el-select>
                  <el-select v-model="i.couponName" placeholder="请选择卡券" clearable>
                    <el-option :label="j.couponsNameDate" :value="j.couponName" v-for="(j,x) in i.couponsList" :key="x"></el-option>
                  </el-select>
                  <i class="el-icon-circle-plus" @click="addTimeRow(i,index)"></i>
                  <i class="el-icon-delete" v-if="item.give.length > 1" @click="delTimeRow(item,d)"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->
                <recharge-rule ref="getrecharge" :form="form" :addType="addType" v-if="paramsObj.templateType == 'recharge_give_coupon'"></recharge-rule>
                <hour-rule ref="getHour" :form="form" :addType="addType" v-if="paramsObj.templateType == 'rank_give_award'"></hour-rule>
                <invite-rule ref="getInvite" :form="form" :addType="addType" v-if="paramsObj.templateType == 'invite_new_user'"></invite-rule>
            </el-form>
            <div class="subBtn">
                <el-button type="primary" @click="subBtn">确 认</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
import rechargeRule from "./marketing/rechargeRule.vue"
import hourRule from "./marketing/hourRule.vue"
import inviteRule from "./marketing/inviteRule.vue"
export default {
    data () {
        return {
            paramsObj: {
                templateType: ''
            },
            billiardsId: JSON.parse(this.$store.state.billiardsInfo).billiardsId,  //商户id
            form: {
                name: '充值送卡券',
                type: '',
                remark: '',
                creatDate: '',
                endDate: '',
                activityList: [],
                activityId: 1,
                ruleList: [],
                hourList: [],
                couponsList: [],
                waterList: [],
                ballList: [],
                consumptionRule: [],
                // 邀请人数
                inviteRule: [],
                // 被邀请获得
                wasInvitedRule: {
                    couponsTypeList: [],
                    couponsTypeText:''
                },
                hourInfo: {
                    totalRankCount: 1,
                    hourList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    coupons: '',
                    couponsType: '',
                }
            },
            radioNum: 1,
            addType: '',
            couponsNumList: [
                {
                    value: 2,
                    label: '水机券',
                },
                {
                    value: 1,
                    label: '台费券',
                },
            ],
        }
    },
    components: {
        rechargeRule,
        hourRule,
        inviteRule
    },
    methods: {
        activeSelect (val) {
            console.log(val, 'vvv');
            this.form.name = val.name
            this.form.activityId = null
            this.form.remark = val.remark
            this.form.type = val.type
            this.form.creatDate = ''
            this.form.endDate = ''
            this.paramsObj.templateType = val.type
            this.form.inviteRule = []
            this.form.consumptionRule = []
            switch (this.paramsObj.templateType) {
                case 'recharge_give_coupon':
                    this.getAdd()
                    break;
                case 'invite_new_user':
                    this.form.creatDate = ''
                    this.form.endDate = ''
                    this.form.wasInvitedRule = {
                        coupons: '',
                        couponsType: null,
                        changeNum: 0,
                        couponsTypeList: [],
                        couponsNumList: this.couponsNumList,
                        give: [],
                    }
                    let invitObj = {
                        inviteNum: '',
                        couponType: '',
                        couponName: '',
                        give: [],
                        couponsList: this.couponsNumList
                    }
                    this.form.inviteRule.push(invitObj)
                    let consumptionObj = {
                        consumptionAmount: '',
                        couponsList: this.couponsNumList,
                        couponType: '',
                        couponName: '',
                        give: [],
                    }
                    this.form.consumptionRule.push(consumptionObj)
                    console.log(this.form);
                    break;
                case 'rank_give_award':
                    this.$nextTick(() => {
                        this.$refs.getHour.getClear()
                    })
                    break;
            }

        },
        async getData (val, item) {
            this.addType = val
            console.log(this.addType, 'addType');
            this.radioNum = 1
            this.form.wasInvitedRule.couponsNumList = this.couponsNumList
            this.form.inviteRule.couponsNumList = this.couponsNumList
            this.form.consumptionRule.couponsNumList = this.couponsNumList
            if (val == 'add') {
                this.getAdd()
            } else {
                switch (item.templateType) {
                    case 'recharge_give_coupon':
                        this.getDetail(item)
                        break;
                    case 'invite_new_user':
                        this.newUserDetail(item)
                        break;
                    case 'rank_give_award':
                        this.getHourDetail(item)
                        break;
                }
            }
        },
        async getHourDetail (item) {
            this.paramsObj = item
            const data = await response(requstsMethod.fun_service_authorized_activity_task_detail, { taskId: item.id })
            console.log(data, 'hour');
            this.form.name = data.name
            this.form.activityId = data.id
            this.form.remark = data.remark
            this.form.type = data.templateType
            this.form.creatDate = data.startTime
            this.form.endDate = data.endTime
            this.form.hourInfo.totalRankCount = data.ruleConfig.totalRankCount
            this.$nextTick(() => {
                this.$refs.getHour.hourList = []
                data.ruleConfig.rule.map((item, index) => {
                    console.log(item, '22222');
                    item.rank = index + 1
                    item.couponsNumList = [
                        {
                            value: 2,
                            label: '水机券',
                        },
                        {
                            value: 1,
                            label: '台费券',
                        },
                    ]
                    if (item.couponUseScopeType == 1) {
                        this.$refs.getHour.getInit(item, item.couponsNumList[0])
                    } else {
                        this.$refs.getHour.getInit(item, item.couponsNumList[1])
                    }
                    if (item.give.length > 0) {
                        item.couponName = item.give[0].couponName
                        item.give[0].couponUseScopeType == 1 ? item.coupons = '台费券' : item.coupons = '水机券'
                        item.couponUseScopeType = item.give[0].couponUseScopeType
                        item.couponId = item.give[0].couponId
                    }
                })
                this.$refs.getHour.hourList.push(...data.ruleConfig.rule)
            })
        },
        async newUserDetail (item) {
            this.paramsObj = item
            const data = await response(requstsMethod.fun_service_authorized_activity_task_detail, { taskId: item.id })
            this.form.name = data.name
            this.form.activityId = data.id
            this.form.remark = data.remark
            this.form.type = data.templateType
            this.form.creatDate = data.startTime
            this.form.endDate = data.endTime
            this.$set(data.ruleConfig.wasInvitedRule, 'couponsTypeText', '')
            this.form.wasInvitedRule = data.ruleConfig.wasInvitedRule
            data.ruleConfig.wasInvitedRule.give[0].length == 0 ? this.form.wasInvitedRule.changeNum = 0 : this.form.wasInvitedRule.changeNum = data.ruleConfig.wasInvitedRule.give[0].couponUseScopeType
            this.form.wasInvitedRule.couponsTypeText = data.ruleConfig.wasInvitedRule.give[0].couponName
            data.ruleConfig.wasInvitedRule.give[0].couponUseScopeType == 2 ? this.form.wasInvitedRule.coupons = '水机券' : this.form.wasInvitedRule.coupons = '台费券'
            this.form.wasInvitedRule.couponsTypeList = []
            data.ruleConfig.inviteRule.map(res => {
                res.give[0].couponUseScopeType == 2 ? res.couponType = '水机券' : res.couponType = '台费券'
                res.couponName = res.give[0].couponName
                res.couponAmount = res.give[0].couponAmount
                res.couponId = res.give[0].couponId
                res.couponNum = res.give[0].couponNum
                res.couponUseScopeType = res.give[0].couponUseScopeType
                res.userId = res.give[0].userId
                res.couponsList = [
                    {
                        value: 2,
                        label: '水机券',
                    },
                    {
                        value: 1,
                        label: '台费券',
                    },
                ]
                this.$nextTick(() => {
                    this.$refs.getInvite.couponTypeChange(res, res.give[0].couponUseScopeType)
                })
            })
            this.form.inviteRule = data.ruleConfig.inviteRule
            data.ruleConfig.consumptionRule.map(res => {
                res.give[0].couponUseScopeType == 2 ? res.couponType = '水机券' : res.couponType = '台费券'
                res.couponName = res.give[0].couponName
                res.couponAmount = res.give[0].couponAmount
                res.couponId = res.give[0].couponId
                res.couponNum = res.give[0].couponNum
                res.couponUseScopeType = res.give[0].couponUseScopeType
                res.userId = res.give[0].userId
                res.couponsList = [
                    {
                        value: 2,
                        label: '水机券',
                    },
                    {
                        value: 1,
                        label: '台费券',
                    },
                ]
                this.$nextTick(() => {
                    this.$refs.getInvite.couponTypeChange(res, res.give[0].couponUseScopeType)
                })
            })
            this.form.consumptionRule = data.ruleConfig.consumptionRule
            this.form.wasInvitedRule.couponsNumList = this.couponsNumList
        },
        async getDetail (item) {
            console.log(this.form.activityId);
            this.paramsObj = item
            const data = await response(requstsMethod.fun_service_authorized_activity_task_detail, { taskId: item.id })
            const billBarams = {
                billiardsId: this.billiardsId,
                useScopeType: 1,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const ballData = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, billBarams)
            ballData.list.map(item => {
                item.validEndTime ? item.couponsNameDate = item.couponName + ' 有效期至' + item.validEndTime : item.couponsNameDate = item.couponName + ' 无限期'
            })
            const waterParams = {
                billiardsId: this.billiardsId,
                useScopeType: 2,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const waterData = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, waterParams)
            waterData.list.map(item => {
                item.validEndTime ? item.couponsNameDate = item.couponName + ' 有效期至' + item.validEndTime : item.couponsNameDate = item.couponName + ' 无限期'
            })
            this.form.name = data.name
            this.form.activityId = data.id
            this.form.remark = data.remark
            this.form.creatDate = data.startTime
            this.form.endDate = data.endTime
            this.form.type = data.templateType
            data.ruleConfig.rule.map(item => {
                if (item.give.length <= 0) {
                    let obj = {
                        couponUseScopeType: 1,
                        couponNum: 1,
                        couponName: '',
                        couponId: null,
                        selectList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    }
                    item.give.push(obj)
                }
                item.give.map(res => {
                    res.selectList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                    if (res.couponUseScopeType == 1 || res.couponUseScopeType == '1') {
                        res.couponsList = ballData.list
                    } else {
                        res.couponsList = waterData.list
                    }
                })
            })
            this.form.ruleList = data.ruleConfig.rule
        },
        async getAdd () {
            const data = await response(requstsMethod.fun_service_authorized_activity_template_list, { version: 1 })
            console.log(data, 'aaaaa');
            this.form.creatDate = ''
            this.form.endDate = ''
            this.paramsObj.templateType = data[0].type
            this.form.activityList = data
            this.form.name = data[0].name
            this.form.remark = data[0].remark
            this.form.activityId = null
            this.form.type = data[0].type
            const res = await response(requstsMethod.fun_Get_Vip_Rule_Get, {})
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: this.radioNum,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const couponData = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            couponData.list.map(item => {
                item.validEndTime ? item.couponsNameDate = item.couponName + ' 有效期至' + item.validEndTime : item.couponsNameDate = item.couponName + ' 无限期'
            })
            res.rechargeRuleList.map((item) => {
                this.$set(item, 'give', [])
                let obj = {
                    couponUseScopeType: 1,
                    couponId: null,
                    couponName: '',
                    couponsNameDate: '',
                    couponNum: 1,
                    selectList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                }
                item.give.push(obj)
                item.give.map(resItem => {
                    resItem.couponsList = couponData.list
                })
            })
            this.form.ruleList = res.rechargeRuleList
        },
        async getCoupon () {
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: this.radioNum,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const data = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            data.list.map(item => {
                item.validEndTime ? item.couponsNameDate = item.couponName + ' 有效期至' + item.validEndTime : item.couponsNameDate = item.couponName + ' 无限期'
            })
            if (this.radioNum == 1 || this.radioNum == '1') {
                this.form.ballList = data.list
            } else {
                this.form.waterList = data.list
            }
        },
        async endDateChange (val) {
            if (val) {
                this.radioNum = 1
                this.form.ruleList.map((item) => {
                    item.give.map(res => {
                        res.couponUseScopeType = 1
                        res.couponName = ''
                        res.couponId = null
                        res.couponNum = 1
                    })
                })
            }
        },
        async couponsBtn (val, obj) {
            this.radioNum = val
            obj.couponName = ''
            obj.couponNum = 1
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: val,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const data = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            data.list.map(item => {
                item.validEndTime ? item.couponsNameDate = item.couponName + ' 有效期至' + item.validEndTime : item.couponsNameDate = item.couponName + ' 无限期'
            })
            if (val == 1) {
                obj.couponsList = data.list
            } else {
                obj.couponsList = data.list
            }
        },
        addTimeRow (item, index) {
            this.form.ruleList.map((res, i) => {
                if (index == i) {
                    let obj = {
                        couponUseScopeType: item.couponUseScopeType,
                        couponId: null,
                        couponName: '',
                        couponNum: 1,
                        selectList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                        couponsList: item.couponsList
                    }
                    res.give.push(obj)
                }
            })
        },
        delTimeRow (item, index) {
            item.give.map((res, i) => {
                if (i == index) {
                    item.give.splice(index, 1)
                }
            })
        },
        getClear () {
            this.form.remark = ''
            this.form.activityId = 1
            this.form.type = ''
            this.form.name = ''
            this.paramsObj = {}
            this.form.creatDate = ''
            this.form.endDate = ''
            this.form.activityList = []
            this.form.ruleList = []
            this.form.hourList = []
            this.form.ballList = []
            this.form.waterList = []
        },
        async subBtn () {
            if (this.form.creatDate == '' || this.form.endDate == '') {
                this.$message({ message: '请选择开始/结束日期', type: 'error' });
            } else {
                switch (this.paramsObj.templateType) {
                    case 'recharge_give_coupon':
                        this.$nextTick(() => {
                            this.$refs.getrecharge.configFn(this.close)
                        })
                        break;
                    case 'invite_new_user':
                        this.$nextTick(() => {
                            this.$refs.getInvite.configFn(this.close)
                        })
                        break;
                    case 'rank_give_award':
                        this.$nextTick(() => {
                            this.$refs.getHour.configFn(this.close)
                        })
                        break;
                }
            }
        },
        close () {
            this.getClear()
            this.$emit('subBtn')
        }
    }
}
</script>

<style lang="scss">
.infoContent {
    padding: 10px;
    .topInfo {
        .subBtn {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin: 20px 20px 0 0;
        }
        .el-form {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            justify-content: flex-start;
            .topTitle {
                font-size: 20px;
                color: #fff;
                text-align: left;
                margin: 10px 0;
            }
            .el-divider {
                margin: 10px 0;
                background-color: #5f5f5f !important;
            }
            .dateBox {
                .el-form-item__content {
                    display: flex;
                    align-items: center;
                    .line {
                        margin: 0 10px;
                    }
                    .el-date-editor {
                        width: 160px !important;
                    }
                }
            }
            .el-form-item {
                margin-bottom: 10px !important;
                .remark {
                    color: #fff;
                }
                .name {
                    font-size: 16px;
                    color: #fff;
                }
                .el-form-item__label {
                    color: #fff;
                    font-size: 16px;
                    font-weight: 500;
                }
                .el-form-item__content {
                    margin-left: 120px !important;
                    .el-select {
                        width: 260px !important;
                        .el-input__inner {
                            height: 35px;
                            line-height: 35px;
                            background-color: #3e3e3e;
                            border: none;
                            box-shadow: 0 0 5px #000 inset;
                            color: #fff;
                        }
                    }
                    .el-input {
                        .el-input__inner {
                            height: 35px;
                            line-height: 35px;
                            background-color: #3e3e3e;
                            border: none;
                            box-shadow: 0 0 5px #000 inset;
                            color: #fff;
                        }
                    }
                }
            }
            .ruleBox {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                .ruleLeft {
                    .ruleList {
                        display: flex;
                        align-items: flex-start;
                        margin: 20px 0;
                        .rule {
                            color: #fff;
                            font-size: 14px;
                            height: 35px;
                            line-height: 35px;
                            margin-right: 15px;
                        }
                        .rule1 {
                            padding-left: 20px;
                        }
                        .rule2 {
                            min-width: 100px;
                            background-color: #323232;
                            border-radius: 4px;
                            padding: 0px;
                        }
                        .rule4 {
                            min-width: 100px;
                            background-color: #323232;
                            border-radius: 4px;
                            padding: 0px;
                        }
                        .couponsList {
                            margin: 0px 0 10px;
                        }
                        .el-radio {
                            .el-radio__label {
                                color: #fff;
                            }
                        }
                        .selectNum {
                            width: 120px !important;
                        }
                        .el-select {
                            width: 350px;
                            margin-right: 20px;
                            .el-input__inner {
                                height: 35px;
                                line-height: 35px;
                                color: #fff;
                                border: none;
                                background-color: #3e3e3e;
                                box-shadow: 0 0 5px #000 inset;
                            }
                        }
                        .el-icon-circle-plus {
                            font-size: 20px;
                            margin-right: 20px;
                            cursor: pointer;
                        }
                        .el-icon-circle-plus:hover {
                            color: #409eff;
                        }
                        .el-icon-delete {
                            font-size: 20px;
                            cursor: pointer;
                        }
                        .el-icon-delete:hover {
                            color: #fd4747;
                        }
                    }
                }
                .ruleRight {
                    .couponsList {
                        display: flex;
                        align-items: center;
                        margin: 20px 0;
                    }
                }
            }
        }
    }
}
</style>